// Updated App.js to use a single Router (provided by index.js)
import React from 'react';
import GalleryPhotoViewer from './pages/gallery/GalleryPhotoViewer';
import { AuthProvider } from './auth/auth-context';
import AppRoutes from './routes/routes';
import { OrgProvider } from './pages/orgs/org-context';
import { ControlPlaneProvider } from './controlPlane/ControlPlaneProvider';
import { ProjectProvider } from './pages/projects/project-context';
import { BrandingProvider } from './contexts/BrandingContext';
import { ToastContainer, Slide } from 'react-toastify';
import { HelpProvider } from './help/HelpContext';
import HelpDrawer from './help/HelpDrawer';
import EveryIdDialogHost from './components/EveryIdDialogHost';

import './App.css';
import './styles/typography.css';

export default function App() {
  // Scoped QR access does not require an Operations login or background org loads.
  if (window.location.pathname === '/gallery/photo') return <GalleryPhotoViewer />;
  return (
    <>
      <AuthProvider>
        <OrgProvider>
          <ControlPlaneProvider>
          <BrandingProvider>
            <ProjectProvider>
              <HelpProvider>
                <AppRoutes />
                <HelpDrawer />
              </HelpProvider>
            </ProjectProvider>
          </BrandingProvider>
          </ControlPlaneProvider>
        </OrgProvider>
      </AuthProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        closeOnClick
        pauseOnHover
        theme="colored"
        transition={Slide}
      />
      <EveryIdDialogHost />
    </>
  );
}
